module.exports = __webpack_public_path__ + "media/images/products/category/sm/8-41185fc95411b5f894b860e83fb23798.jpg";